import React, { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { HomeCrubIcon } from "../../assets/imageAssets";

const findNodeName = (topics, id) => {
  for (const topic of topics || []) {
    if (topic.id === Number(id)) return topic.name;
    const found = findNodeName(topic.topics, id);
    if (found) return found;
  }
  return null;
};

const Breadcrumbs = () => {
  const { profileId, topicId, "*": rest } = useParams();
  const { profileName, topicsTree } = useSelector(state => state.topics);

  const crumbs = useMemo(() => {
    const result = [];

    result.push({ key: "home", name: "Home", url: "/" });

    if (!profileId) return result;

    result.push({
      key: `profile-${profileId}`,
      name: profileName || null,
      isLoading: !profileName,
      url: `/profiles/${profileId}/topics`,
    });

    if (!topicId) return result;

    const segments = (rest || "").split("/").filter(Boolean);
    const isQuestionsView = segments.length > 0 && segments[segments.length - 1] === "questions";
    const subtopicIds = segments.filter(s => s !== "subtopics" && s !== "questions");

    // Full chain of IDs from topicId down through subtopicIds
    const idChain = [topicId, ...subtopicIds];

    // Build the URL for each level in the chain
    const urls = [];
    let currentUrl = `/profiles/${profileId}/topics/${topicId}`;
    urls.push(currentUrl);
    for (const subId of subtopicIds) {
      currentUrl = `${currentUrl}/subtopics/${subId}`;
      urls.push(currentUrl);
    }

    // In questions view, all IDs in the chain are navigable except the last (current page)
    idChain.forEach((id, idx) => {
      const name = findNodeName(topicsTree, id);
      const isLast = idx === idChain.length - 1;
      result.push({
        key: `node-${id}`,
        name: name || null,
        isLoading: !name,
        url: isLast || !name ? null : urls[idx],
      });
    });

    return result;
  }, [profileId, topicId, rest, profileName, topicsTree]);

  return (
    <div className="breadcrumbs">
      <ul className="breadcrumbs__list flex flex-align-center flex-justify-center flex-wrap">
        {crumbs.map(crumb => (
          <li className="breadcrumbs__item" key={crumb.key}>
            {crumb.isLoading ? (
              <span className="breadcrumbs__skeleton" aria-hidden="true" />
            ) : crumb.url ? (
              <Link to={crumb.url}>
                {crumb.key === "home" ? <img src={HomeCrubIcon} alt="Home" /> : crumb.name}
              </Link>
            ) : (
              <span>{crumb.name}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
